import {FETCH_BALANCE, LIST_BALANCE} from "./types";

const init = {
    isLoading: false,
    data: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_BALANCE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_BALANCE:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        default:
            return state

    }
}
